
import Vue, { PropType } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ITireAttributeValue } from 'JS/types/PDP';

interface AttributeWithIndex {
	index: number;
	attribute: ITireAttributeValue;
}

@Component({
	name: 'TireSpecifications',
})
class TireSpecifications extends Vue {
	@Prop({ type: Array as PropType<ITireAttributeValue[]>, required: true })
	attributes: ITireAttributeValue[];

	@Prop({ type: Object as PropType<Record<string, string>[]>, required: true })
	additionalAttributes: Record<string, string>[];

	getAttributeItemClass(index: number) {
		return `tire-specs__item--${index % 2 === 0 ? 'even' : 'odd'}`;
	}

	get attributesWithIndex(): AttributeWithIndex[] {
		return this.attributes.filter(attribute => {
			return attribute.attributeDescription !== 'Tire Size';
		})?.map((attribute, index) => ({ attribute, index }));
	}

	get tireSize(): string {
		return this.attributes.find(attribute => {
			return attribute.attributeDescription === 'Tire Size';
		})?.attributeValue;
	}
}

export default TireSpecifications;
